import React, { Component } from "react";
import "react-toastify/dist/ReactToastify.css";
import SimpleModalWrapped from "../common/Modal";
import TextField from "../common/TextField";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";

const styles = () => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
});

class AddPmsIntervalModal extends Component {
  render() {
    const categories = Array.isArray(this.props.categories)
      ? this.props.categories
      : [];
    const isEdit = Boolean(this.props.isEdit);

    return (
      <SimpleModalWrapped
        {...this.props}
        visable
        isButtonVisable
        title={this.props.title}
        formSubmit={this.props.formSubmit}
        modalControle={this.props.modalControle}
        btnclosetext={this.props.translate("sharedBack")}
        buttonText={this.props.buttonText}
        isVisableBtn={this.props.isVisableCreateBtn}
        content={
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <TextField
                id="category"
                label={this.props.translate("pmsCategory")}
                type="text"
                value={this.props.form?.category || ""}
                onChange={this.props.handleChange("category")}
                variant="outlined"
                margin="dense"
                fullWidth
                required
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <TextField
                id="fleetType"
                select
                label={this.props.translate("vehicleType")}
                value={
                  isEdit
                    ? this.props.form?.fleetTypes?.[0] || ""
                    : this.props.form?.fleetTypes || []
                }
                onChange={this.props.handleFleetTypesChange}
                variant="outlined"
                margin="dense"
                fullWidth
                required
                SelectProps={
                  isEdit
                    ? undefined
                    : {
                        multiple: true,
                        renderValue: (selected) => selected.join(", "),
                      }
                }
              >
                {categories.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <TextField
                id="baselineInterval"
                label={this.props.translate("baselineInterval")}
                type="number"
                value={this.props.form?.baselineInterval ?? ""}
                onChange={this.props.handleChange("baselineInterval")}
                variant="outlined"
                margin="dense"
                fullWidth
                required
                inputProps={{ min: 0 }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <TextField
                id="baselineIntervalDays"
                label={this.props.translate("baselineIntervalDays")}
                type="number"
                value={this.props.form?.baselineIntervalDays ?? ""}
                onChange={this.props.handleChange("baselineIntervalDays")}
                variant="outlined"
                margin="dense"
                fullWidth
                required
                inputProps={{ min: 0 }}
              />
            </Grid>
          </Grid>
        }
      />
    );
  }
}

export default withStyles(styles)(AddPmsIntervalModal);
